import React from 'react';
import './subHeader2.less';
import { StepsBar } from '..';

/* 
[Component Usage]
<SubHeader
title={() => (
    <span className="title">
        Welcome, <span className="title-bold">John</span>{' '}
    </span>
)}
subTitle={() => <span className="subtitle">Somethings to show you</span>}
hasStepsBar
></SubHeader> */

export enum SubHeader2Appearance {
	screenHeaderTitle,
}

export interface SubHeader2Props {
	/**sets sub header appearance */
	appearance: SubHeader2Appearance;
	/** Title */
	title?: string;
	/** Subtitle */
	subTitle?: string;
	/** Custom Title */
	customTitle?: () => React.ReactNode;
	/** Custom Subtitle */
	customSubTitle?: () => React.ReactNode;
	/** Possibility to have progress indicator or not */
	hasStepsBar?: boolean;
	/** Progress indicator steps */
	steps?: string[];
	/** Current step of the progress indicator */
	step?: number;
}

export const SubHeader2: React.FC<SubHeader2Props> = (props: SubHeader2Props): JSX.Element => {
	const { title, subTitle, customTitle, customSubTitle, hasStepsBar, step, steps, appearance } = props;

	return (
		<div className={`it-subHeader${getAppearanceClass(appearance)}`}>
			<div className="subHeader-subContainer">
				<div className="ds-title">
					{title ? <span className="title-page">{title}</span> : customTitle && customTitle()}
				</div>
				<div className="subHeader-bottomContainer">
					<div className="ds-subtitle">
						{subTitle ? (
							<span className="subtitle-page">{subTitle}</span>
						) : (
							customSubTitle && customSubTitle()
						)}
					</div>
					{hasStepsBar ? (
						<div className="stepsBar">
							<StepsBar currentStep={step ? step : 1} steps={steps}></StepsBar>
						</div>
					) : (
						''
					)}
				</div>
			</div>
		</div>
	);
};

const getAppearanceClass = (appearance: SubHeader2Appearance): string => {
	if (appearance === SubHeader2Appearance.screenHeaderTitle) {
		return ' screen-header-title';
	}

	return '';
};
